package oldcomponents


@Suppress("ConvertSecondaryConstructorToPrimary")
@JsModule("noty")
@JsNonModule
external class Noty {
    constructor(obj: dynamic) { definedExternally }
    fun show()
}

fun showNotification(
    text: String,
    type: NotyType = NotyType.Notification,
    direction: NotyDirection = NotyDirection.TopRight,
    timeout: Int = 5000,
    closeCallback: (()->Unit)? = null
) {
    if (type == NotyType.Error) {
        console.error(text)
    }
    val animationType: String = if (direction == NotyDirection.Center) {
        "fade"
    } else {
        "bounce"
    }
    val animationDirection: String = when (direction) {
        NotyDirection.Top,
        NotyDirection.TopCenter -> {
            "Top"
        }
        NotyDirection.Bottom,
        NotyDirection.BottomCenter -> {
            "Bottom"
        }
        NotyDirection.TopLeft,
        NotyDirection.BottomLeft,
        NotyDirection.CenterLeft -> {
            "Left"
        }
        NotyDirection.TopRight,
        NotyDirection.BottomRight,
        NotyDirection.CenterRight -> {
            "Right"
        }
        else -> {
            ""
        }
    }

    val obj  = js("{}")
    obj.type = type.name.lowercase()
    obj.layout = "topRight"
    obj.text = text
    obj.progressBar = timeout >= 0
    obj.timeout = if (timeout >= 0) timeout else false
//    obj.theme = "metroui"
    obj.callbacks = kotlinext.js.js {
        onClose = closeCallback
    }
    Noty(obj).show()
}

enum class NotyType {
    Notification,
    Success,
    Warning,
    Error,
    Info
}
enum class NotyDirection {
    Top,
    TopLeft,
    TopRight,
    TopCenter,
    Center,
    CenterLeft,
    CenterRight,
    Bottom,
    BottomLeft,
    BottomRight,
    BottomCenter,
}